<script>
// import Flickity from 'flickity';
import barba from '@barba/core';
import Swiper from 'swiper';
import SwiperCore, { Keyboard, Mousewheel, HashNavigation, Pagination } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Keyboard, Mousewheel, HashNavigation, Pagination]);

export default {
    name: 'Gallery',
    components: {
    },
    data () {
        return {
            description: ''
        }
    },
    mounted() {
        this.swiper = new Swiper(this.$refs.swiper, {
            slidesPerView: 1,
            simulateTouch: true,
            direction: 'vertical',
            loop: this.$refs.swiper.querySelectorAll('.swiper-slide').length > 1,
            hashNavigation: {
                replaceState: true,
                watchState: true,
            },
            // shortSwipes: false,
            mousewheel: {
                sensitivity: 200,
            },
            spaceBetween: 200,
            speed: 600,
            // pagination: {
            //     type: 'fraction',
            //     el: this.$refs.pagination
            // },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            simulateTouch: false
        });

        this.$refs.swiper.querySelectorAll('.swiper-slide').forEach(el => {
            el.addEventListener('click', this.handleClickNext)
        })

        this.swiper.on('slideChange', () => {
            this.updateDescription();
        });

        window.swiper = this.swiper;

        window.addEventListener('previewClick', this.handleClick, false);

        this.$nextTick(() => {
            this.updateDescription();
            this.swiper.update()
        });

        barba.hooks.after(() => {
            if (this && this.swiper) {
                this.swiper.update();
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('previewClick', this.handleClick, false);
        this.$refs.swiper.querySelectorAll('.swiper-slide').forEach(el => {
            el.removeEventListener('click', this.handleClickNext)
        })
        this.swiper.destroy()
    },
    computed: {
        currentText() {
            return `${this.active} / ${this.total}`
        }
    },
    methods: {
        handleClick (e) {
            this.swiper.slideTo(e.detail)
        },
        handleClickNext (e) {
            this.swiper.slideNext();
        },
        updateDescription() {
            const currentSlide = this.swiper.slides[this.swiper.activeIndex];
            let descriptionEl;
            if (currentSlide && (descriptionEl = currentSlide.querySelector('.gallery__description')) && descriptionEl.textContent) {
                this.description = descriptionEl.textContent;
            } else {
                this.description = '';
            }
        }
    }
}
</script>
